module.exports = __webpack_public_path__ + "static/media/chitty_mascot.62d14256.svg";